// The config port: everything the packages need from the environment the app was built for.
// The packages never read the build environment themselves. The app builds this object from its
// validated env schema and hands it over before anything renders; tests hand over a fixture.

type Alarm = {
	timeout: number;
	sound: string;
};

export type TerminalConfig = {
	alarms: {
		totalAlarmTimeout: number;
		refillWarningTimeout: number;
		displayWarningTimeout: number;
		firstAlarm: Alarm;
		secondAlarm: Alarm;
		thirdAlarm: Alarm;
	};
	aws: {
		apiKey: string;
		appsyncUrl: string;
		region: string;
	};
	connectionSettings: {
		connectionTimeout: number;
		initialStateQueryRefetchDebounce: number;
	};
	dishTypePlaceholderImage: string;
	build: {
		/**
		 * Vite mode the bundle was built in: "production", "staging", "development", "test", or "proto"
		 * for the prototype playground, which runs on the mock server alone.
		 */
		mode: string;
		/** VITE_ENV, the environment the bundle is deployed to. */
		env: string | undefined;
		appVersion: string | undefined;
		buildNumber: string | undefined;
		/** VITE_REFETCH_NEXT_HOUR_OVERRIDE, milliseconds; honoured outside production only. */
		refetchNextHourOverride: string | undefined;
	};
};

let terminalConfig: TerminalConfig | null = null;

export const setTerminalConfig = (config: TerminalConfig): void => {
	terminalConfig = config;
};

export const getTerminalConfig = (): TerminalConfig => {
	if (terminalConfig === null) {
		throw new Error("Terminal config is not set. Call setTerminalConfig() before anything reads it.");
	}
	return terminalConfig;
};
